import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { UseFormReturn } from "react-hook-form";
import HeightSelector from "./HeightSelector";
import { useTranslation } from "@/hooks/useTranslation";

export default function HeightField({
  form,
  optional,
}: {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  form: UseFormReturn<any>;
  optional?: boolean;
}) {
  const t = useTranslation();

  return (
    <FormField
      control={form.control}
      name="height"
      render={({ field }) => (
        <FormItem className="grid grid-cols-1 sm:grid-cols-[1fr_2fr] items-center">
          <FormLabel
            className={optional ? "text-gray-400" : ""}
            htmlFor="height"
          >
            {t.USER_FORM.LABELS.HEIGHT}
          </FormLabel>
          <div>
            <FormControl>
              <HeightSelector value={field.value} onChange={field.onChange} />
            </FormControl>
            <FormMessage className="mt-1" />
          </div>
        </FormItem>
      )}
    />
  );
}
